import { render, staticRenderFns } from "./insuranceSetup.vue?vue&type=template&id=1823342e&"
import script from "./insuranceSetup.vue?vue&type=script&lang=js&"
export * from "./insuranceSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports